import 'store/bolt/pixels.js';
import Store from 'store/store';
import { loadScript } from 'utils/utils';
import * as categories from 'utils/gdpr/categories';

const DIRECT = 'direct';
const FANDANGO = 'fandango';
const TRAILER = 'trailer';

let adWordsLandingFired = false;
let amazonLandingFired = false;
let floodlightLandingFired = false;

const catChangeListener = (cats) => {
	if (cats.includes('SOCIAL')) {
		if (!window.rdt) {
			fireRedditLanding();
		}
		if (!window.fbq) {
			fireFacebookLanding('350005663196308');
			fireFacebookLanding('1126552544805147');
			fireFacebookViewContent();
		}
		if (!window.snaptr) {
			fireSnapchatLanding();
		}
		if (!window.twq) {
			fireTwitterLanding();
		}
		if (!window.ttq) {
			fireTiktokLanding();
		}
	}
	if (cats.includes('TARGETING')) {
		if (!adWordsLandingFired) {
			fireAdwordsLanding();
		}
		if (!amazonLandingFired) {
			fireAmazonLanding();
		}
		if (!floodlightLandingFired) {
			fireFloodlightLanding();
		}
	}
};


// SOCIAL

// Reddit
const fireRedditLanding = () => {
	!function(w, d) {
		if (!w.rdt) {
			let p = w.rdt = function() {
				p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
			};
			p.callQueue = [];
			let t = d.createElement('script');
			t.src = 'https://www.redditstatic.com/ads/pixel.js', t.async = !0;
			let s = d.getElementsByTagName('script')[0];
			s.parentNode.insertBefore(t, s);
		}
	}(window, document);
	window.rdt('init', 't2_j4b3sdme');
	window.rdt('track', 'PageVisit');
};

const fireRedditSearch = () => {
	if (window.rdt) {
		window.rdt('track', 'Search');
	}
};

const fireRedditTicketConversion = () => {
	if (window.rdt) {
		window.rdt('track', 'Custom', {
			customEventName: 'GetShowtime'
		});
	}
};

// Facebook
const fireFacebookLanding = (id) => {
	if (!window.fbq) {
		!function(f, b, e, v, n, t, s) {
			if (f.fbq) return;
			n = f.fbq = function() {
				n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
			};
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = '2.0';
			n.queue = [];t = b.createElement(e); t.async = !0;
			t.src = v; s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s);
		}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
	}
	fbq('init', id);
	fbq('track', 'PageView');
};

const fireFacebookViewContent = () => {
	if (window.fbq) {
		fbq('track', 'ViewContent');
	}
};

const fireFacebookConversion = () => {
	if (window.fbq) {
		fbq('track', 'AddToCart');
	}
};

// Snapchat
const fireSnapchatLanding = () => {
	(function(e, t, n) {
		if (e.snaptr) return;
		let a = e.snaptr = function () {
			a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
		};
		a.queue = [];
		let s = 'script';
		let r = t.createElement(s);
		r.async = !0;
		r.src = n;
		let u = t.getElementsByTagName(s)[0];
		u.parentNode.insertBefore(r, u);
	})(window, document, 'https://sc-static.net/scevent.min.js');

	window.snaptr('init', 'a3b8269f-376b-4510-a0ce-faebdfede4e1', {
		'user_email': '__INSERT_USER_EMAIL__'
	});

	window.snaptr('track', 'PAGE_VIEW');
	window.snaptr('track', 'VIEW_CONTENT');
};

const fireSnapchatConversion = () => {
	if (window.snaptr) {
		window.snaptr('track', 'ADD_CART');
	}
};

// Twitter
const fireTwitterLanding = () => {
	!function(e, t, n, s, u, a) {
		e.twq || (s = e.twq = function() {
			s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
		},
		s.version = '1.1',
		s.queue = [],
		u = t.createElement(n),
		u.async = !0,
		u.src = '//static.ads-twitter.com/uwt.js',
		a = t.getElementsByTagName(n)[0],
		a.parentNode.insertBefore(u, a));
	}(window, document, 'script');

	window.twq('init', 'o8h1j');
	window.twq('track', 'PageView');
};

const fireTwitterTicketConversion = async () => {
	try {
		if (!window.twttr || !window.twttr.conversion) {
			await loadScript('https://static.ads-twitter.com/oct.js');
		}
		window.twttr.conversion.trackPid('o8h1q', {
			tw_sale_amount: 0,
			tw_order_quantity: 0
		});
	} catch (e) {}
};

// Tiktok
const fireTiktokLanding = () => {
	!function (w, d, t) {
		w.TiktokAnalyticsObject = t;
		let ttq = w[t] = w[t] || [];
		ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'],
		ttq.setAndDefer = function (t, e) {
			t[e] = function () {
				t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
			};
		};
		for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
		ttq.instance = function (t) {
			for (let e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
			return e;
		},
		ttq.load = function (e, n) {
			let i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
			ttq._i = ttq._i || {},
			ttq._i[e] = [],
			ttq._i[e]._u = i,
			ttq._t = ttq._t || {},
			ttq._t[e] = +new Date,
			ttq._o = ttq._o || {},
			ttq._o[e] = n || {};
			let o = document.createElement('script');
			o.type = 'text/javascript',
			o.async = !0,
			o.src = i + '?sdkid=' + e + '&lib=' + t;
			let a = document.getElementsByTagName('script')[0];
			a.parentNode.insertBefore(o, a);
		};

		ttq.load('C9EQN6JC77U12DDTH5NG');
		ttq.page();
	}(window, document, 'ttq');

	window.ttq.track('ViewContent');
};

const fireTiktokConversion = () => {
	if (window.ttq) {
		window.ttq.track('AddToCart');
	}
};

// TARGETING (Advertising)

// Adwords
function gtag () {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(arguments);
}

const fireAdwordsLanding = async () => {
	adWordsLandingFired = true;
	try {
		await loadScript('https://www.googletagmanager.com/gtag/js?id=AW-1070823756');
		gtag('js', new Date());
		gtag('config', 'AW-1070823756');
		gtag('event', 'conversion', {
			'send_to': 'AW-1070823756/Q1ymCPTd3LQDEMzyzf4D'
		});
	} catch (e) {}
};

const fireAdWordsConversion = (source) => {
	const conversionIDs = {
		[DIRECT]: 'chunCLOkp7QDEMzyzf4D',
		[FANDANGO]: 'a3yyCPHj3LQDEMzyzf4D'
	};

	gtag('event', 'conversion', {
		'send_to': `AW-1070823756/${conversionIDs[source]}`
	});
};

// Floodlight
const fireFloodlightLanding = async () => {
	floodlightLandingFired = true;
	try {
		await loadScript('https://www.googletagmanager.com/gtag/js?id=DC-8299675');
		gtag('js', new Date());
		gtag('config', 'DC-8299675');
		gtag('event', 'conversion', {
			'allow_custom_scripts': true,
			'send_to': 'DC-8299675/powst0/2020_005+standard'
		});
	} catch (e) {}
};

const fireFloodlightEvent = (source) => {
	const conversionIDs = {
		[DIRECT]: '2020_006+standard',
		[FANDANGO]: '2020_007+standard',
		[TRAILER]: '2020_008+standard'
	};

	gtag('event', 'conversion', {
		'allow_custom_scripts': true,
		'send_to': `DC-8299675/powst0/${conversionIDs[source]}`
	});
};


// Amazon
const fireAmazon = (id) => {
	let protocol = '//';
	let a = Math.random() * 1000000000000000000;
	let _pix = document.createElement('iframe');
	_pix.style.display = 'none';
	_pix.setAttribute('src', protocol + `s.amazon-adsystem.com/iu3?d=generic&ex-fargs=%3Fid%3D${id}%26type%3D55%26m%3D1&ex-fch=416613&ex-src=https://www.topgunmovie.com/&ex-hargs=v%3D1.0%3Bc%3D6428079060401%3Bp%3D${id.toUpperCase()}` + '&cb=' + a);
	_pix.setAttribute('id', `_pix_id_${id}`);
	document.body.appendChild(_pix);
};

const fireAmazonLanding = () => {
	fireAmazon('c6183bc3-8b8c-8f50-b795-3e539495af4a');
	amazonLandingFired = true;
};

const fireAmazonTrailerView = () => {
	fireAmazon('5d95435d-68e7-5289-ee21-991790446d27');
};

const fireAmazonDirectTheaterConversion = () => {
	fireAmazon('4bbc1a7e-184c-a9eb-35f9-f82911c044d8');
};

const fireAmazonFandangoConversion = () => {
	fireAmazon('6890819b-85e1-0439-9b5b-1c4f2a188e75');
};


// EVENTS
Store.on('LANDING', () => {
	if (!categories.has('SOCIAL') || !categories.has('TARGETING')) {
		categories.addChangeListener(catChangeListener);
	}
	if (categories.has('SOCIAL')) {
		fireRedditLanding();
		fireFacebookLanding('1126552544805147');
		fireFacebookLanding('350005663196308');
		fireFacebookViewContent();
		fireSnapchatLanding();
		fireTwitterLanding();
		fireTiktokLanding();
	}
	if (categories.has('TARGETING')) {
		fireAdwordsLanding();
		fireAmazonLanding();
		fireFloodlightLanding();
	}
});

Store.on('TICKET_CONVERSION', (data, page) => {
	if (categories.has('SOCIAL')) {
		fireRedditTicketConversion();
		fireFacebookConversion();
		fireSnapchatConversion();
		fireTwitterTicketConversion();
		fireTiktokConversion();
	}
	if (categories.has('TARGETING')) {
		if (data.provider === DIRECT) {
			fireAdWordsConversion(DIRECT);
			fireAmazonDirectTheaterConversion();
			fireFloodlightEvent(DIRECT);
		}
		if (data.provider === FANDANGO) {
			fireAdWordsConversion(FANDANGO);
			fireAmazonFandangoConversion();
			fireFloodlightEvent(FANDANGO);
		}
	}
});

Store.on('SET_USER_LOCATION', (data, source) => {
	if (source !== 'landing' && categories.has('SOCIAL')) {
		fireRedditSearch();
	}
});

Store.on('VIDEO_PLAYER_PROGRESS', (data) => {
	if (data.platform === 'youtube' && data.step === 0) {
		fireAmazonTrailerView();
		fireFloodlightEvent(TRAILER);
	}
});
